export default __webpack_public_path__ + "static/media/soundcloud.b9638d26.svg";